<hs-no-loaded-account [content]="loadedAccountDependentContent">
</hs-no-loaded-account>

<ng-template #loadedAccountDependentContent>
  <hs-cache-load-listener
    [content]="cacheDependentContent"
    [sessionCacheStatus]="sessionCacheStatus"
    [sessionId]="currentSessionId"
    [accountIds]="currentAccountIds"
    [notApplicable]="notApplicable"
    [notApplicableMessage]="notApplicableMessage"
  ></hs-cache-load-listener>
</ng-template>

<ng-template #cacheDependentContent>
  <div class="positions-grid-container" #positionsGridContainer>
    <hs-positions-grid
      #positionsGrid
      [rowsUpdated]="updatedPositions$ | async"
      [focusedSecurityId]="focusedSecurityId$ | async"
      (securityIdFilterSelected)="setSecurityIdFilter($event)"
      (currencyFilterSelected)="setCurrencyFilter($event)"
      (positionSelected)="setSelectedPosition($event)"
    >
    </hs-positions-grid>
  </div>

  <hs-resize-handle
    [elem1]="positionsGridContainer"
    [elem2]="subPanels"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>

  <div id="positions-sub-panels" #subPanels>
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li [ngbNavItem]="1">
        <a class="position-nav-item" ngbNavLink> External Comparison </a>
        <ng-template ngbNavContent>
          <hs-external-comparison
            #externalComparison
            *ngIf="selectedPosition; else noPosition"
            [position]="selectedPosition"
            [rowsUpdated]="updatedPositions$ | async"
          ></hs-external-comparison>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a class="position-nav-item" ngbNavLink>
          Historical Balance Comparison
        </a>
        <ng-template ngbNavContent>
          <hs-historical-balance-comparison
            #historicalBalanceComparison
            *ngIf="selectedPosition; else noPosition"
            [position]="selectedPosition"
            [rowsUpdated]="updatedPositions$ | async"
          ></hs-historical-balance-comparison>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a class="position-nav-item" ngbNavLink> External Position Detail </a>
        <ng-template ngbNavContent>
          <hs-external-position-detail
            #externalPositionDetail
            *ngIf="selectedPosition; else noPosition"
            [position]="selectedPosition"
            [isMultipleSelected]="isMultipleSelected"
          ></hs-external-position-detail>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
  <ng-template #noPosition>
    <hs-panel-card header="No Position Selected">
      <p>
        This panel requires a position to be selected before information can be
        displayed. Select a position to continue.
      </p>
    </hs-panel-card>
  </ng-template>
</ng-template>
